// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationGenerator-cls1_4Eq","cls2":"CitationGenerator-cls2_h8T CitationGenerator-cls1_4Eq"};